const production = false;

export const environment = {
  production: production,
  baseUrl: production ? 'https://api.barbook.es/' : 'https://api.dev.barbook.es/',
  shareUrl: {
    protocol: 'https',
    domain: 'app.barbook.es',
    path: 'share.html'
  },
  firebase: {
    apiKey: 'AIzaSyBkP85xdJQAVQY9k3G7uGfRWECnEaydMC0',
    authDomain: 'barbook-adrcanfer.firebaseapp.com',
    projectId: 'barbook-adrcanfer',
    storageBucket: 'barbook-adrcanfer.appspot.com',
    messagingSenderId: '859585965276',
    appId: '1:859585965276:web:d6a77bdc2c09f662bfd819',
    measurementId: 'G-VM20MM5J91',
  },
  googleClientId: '859585965276-8tpg7k0fbsap4kipo54dhj5tqs3vtl2u.apps.googleusercontent.com',
};
